import { useLocation } from "react-router-dom";

interface ToolTheme {
  color: string;
  label: string;
}

interface ToolRoute extends ToolTheme {
  // Path prefixes that belong to this tool. Mirrors the grouping NavMenu.tsx
  // uses to decide which nav item is "selected" (e.g. /order-intake* is part
  // of Príjem tovaru), so the frame/label always agrees with the nav.
  paths: string[];
}

// Vivid, mutually distinct colors so no two tools can be mistaken for each
// other, even glancing at the screen mid-scan. Anchored on the app's existing
// blue (#1890FF - primary buttons, selected tab) and orange (#FA8C16 - the
// "Skenovanie" status tag), with the rest of the wheel filled in around them.
const TOOL_ROUTES: ToolRoute[] = [
  { paths: ["/incoming", "/order-intake"], color: "#B0B609", label: "PRÍJEM TOVARU" },
  { paths: ["/inventory-move"], color: "#60B50B", label: "PRESUN TOVARU" },
  { paths: ["/position-stocktaking"], color: "#F5222D", label: "INVENTÚRA POZÍCIE" },
  { paths: ["/sku-stocktaking"], color: "#FA8C16", label: "INVENTÚRA SKU" },
  { paths: ["/temporary-positions"], color: "#721DFD", label: "DOČASNÉ POZÍCIE" },
  { paths: ["/product-search"], color: "#E30FE8", label: "TLAČ ŠTÍTKOV" },
  { paths: ["/recommended-moves"], color: "#0F9552", label: "ODPORÚČANÉ PRESUNY" },
];

/**
 * Color/label for the currently active tool (SIG-88): every tool gets a
 * colored frame around the viewport and a pinned label strip, both always
 * visible regardless of scroll position or how the nav bar collapses at
 * mobile widths.
 */
export const useActiveToolTheme = (): ToolTheme | null => {
  const location = useLocation();
  const path = location.pathname === "/" ? "/incoming" : location.pathname;
  const route = TOOL_ROUTES.find((candidate) => candidate.paths.some((prefix) => path.startsWith(prefix)));
  return route ? { color: route.color, label: route.label } : null;
};
